import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import PartnerWizardModalTemplate from './modal/partner-wizard-modal.template';
import PartnerWizardButtonsOrderTemplate from './partner-wizard-buttons-order.template';
import PartnerWizardButtonsModalTemplate from './partner-wizard-buttons-modal.template';
import { PartnerWizardComponent } from '../cwc-partner-wizard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardTemplate: FunctionalComponent<PartnerWizardTemplateProps> = ({ controller }) => {
  // render direct order buttons (no modal)
  if (!controller.wizardData.tradingPartners.length && !controller.forceModalView) {
    if (!controller.wizardData.orderChannels) {
      return <p>{controller.textFallback}</p>;
    } else {
      return (
        <Host>
          <PartnerWizardButtonsOrderTemplate controller={controller} />
        </Host>
      );
    }
  }

  // render buttons with modal
  return (
    <Host>
      <PartnerWizardButtonsModalTemplate controller={controller} />

      <PartnerWizardModalTemplate controller={controller} />
    </Host>
  );
};

export default PartnerWizardTemplate;
